export default () => ({
  list: [],
  listExceptId: []
})
